import { formatKey } from '../Utils/Functions';
import * as actions from './Actions';

const parsePoste = (payload) => {
    // Handle different ID field names (id or posteId)
    const posteId = payload.posteId || payload.id;
    
    return {
        posteId: posteId,
        name: payload.name,
        // Normalize discipline fields when present
        disciplineId: payload.disciplineId || payload.discipline_id || payload.discipline?.discipline_id || null,
        discipline: payload.discipline || null,
        createdBy: payload.createdBy,
        createdAt: payload.createdAt,
        updatedAt: payload.updatedAt,
        users: payload.users || [],
    };
};

export const postesReducer = (state = [], action) => {
    switch (action.type) {
        case actions.INITIALIZE_POSTES:
                return action.payload.map(poste => parsePoste(poste));

        case actions.ADD_POSTE:
                return [...state, parsePoste(action.payload)];

        case actions.UPDATE_POSTE:
            return state.map(poste =>
                poste.posteId === action.payload.posteId ? parsePoste(action.payload) : poste
            );

        case actions.DELETE_POSTE:
            return state.filter(poste => poste.posteId !== action.payload.posteId);
        

        case actions.CLEAR_POSTES_LIST:
            return [];

        // Assign poste to a discipline: update the poste's discipline info
        case actions.ASSIGN_POSTE_TO_DISCIPLINE:
            return state.map(poste =>
                poste.posteId === (action.payload.posteId || action.posteId)
                    ? {
                        ...poste,
                        discipline: action.payload.discipline || action.discipline || null,
                        disciplineId:
                            action.payload.disciplineId ||
                            action.disciplineId ||
                            action.payload.discipline?.discipline_id ||
                            action.payload.discipline?.id || null,
                      }
                    : poste
            );

        default:
            return state;
    }
};
